<mat-card
  class="rounded-[1.5rem]! shadow-none! border-[1.5px]! border-(--slate-background)!"
  data-testid="waiting-on-you-card-skeleton__card"
>
  <mat-card-header
    class="w-full bg-(--color-todo-card-bg-primary)! rounded-t-[1.25rem]!"
    data-testid="waiting-on-you-card-skeleton__header"
  >
    <div
      class="w-full flex flex-col gap-2 py-[0.75rem]! px-[0.75rem]!"
      data-testid="waiting-on-you-card-skeleton__header-inner"
    >
      <ngx-skeleton-loader
        animation="pulse"
        [theme]="{
          height: '18px',
          width: '40%',
          margin: '0',
          borderRadius: '4px',
        }"
      />
      <div class="w-full flex flex-row justify-between items-center">
        <div class="flex flex-row gap-4 items-center">
          <ngx-skeleton-loader
            animation="pulse"
            [theme]="{
              height: '14px',
              width: '70px',
              margin: '0',
              borderRadius: '3px',
            }"
          />
          <ngx-skeleton-loader
            animation="pulse"
            [theme]="{
              height: '14px',
              width: '90px',
              margin: '0',
              borderRadius: '3px',
            }"
          />
        </div>
        <div class="flex flex-row gap-2">
          <ngx-skeleton-loader
            animation="pulse"
            [theme]="{
              height: '22px',
              width: '70px',
              margin: '0',
              borderRadius: '10px',
            }"
          />
          <ngx-skeleton-loader
            animation="pulse"
            [theme]="{
              height: '22px',
              width: '60px',
              margin: '0',
              borderRadius: '10px',
            }"
          />
        </div>
      </div>
    </div>
  </mat-card-header>
  <mat-card-content
    class="border-t-[1.5px]! border-(--slate-background)!"
    data-testid="waiting-on-you-card-skeleton__content"
  >
    <div
      class="w-full flex flex-col gap-3 py-[0.75rem]! px-[0.75rem]!"
      data-testid="waiting-on-you-card-skeleton__content-inner"
    >
      <ngx-skeleton-loader
        animation="pulse"
        [theme]="{
          height: '16px',
          width: '45%',
          margin: '0',
          borderRadius: '3px',
        }"
      />
      <div class="w-full flex flex-row justify-between items-center gap-4">
        <ngx-skeleton-loader
          animation="pulse"
          [theme]="{
            height: '14px',
            width: '60%',
            margin: '0',
            borderRadius: '3px',
          }"
        />
        <ngx-skeleton-loader
          animation="pulse"
          [theme]="{
            height: '32px',
            width: '110px',
            margin: '0',
            borderRadius: '8px',
          }"
        />
      </div>
      <div class="w-full flex flex-row gap-2 items-center">
        <ngx-skeleton-loader
          animation="pulse"
          [theme]="{
            height: '14px',
            width: '14px',
            margin: '0',
            borderRadius: '3px',
          }"
        />
        <ngx-skeleton-loader
          animation="pulse"
          [theme]="{
            height: '12px',
            width: '120px',
            margin: '0',
            borderRadius: '3px',
          }"
        />
      </div>
    </div>
  </mat-card-content>
</mat-card>
